var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M14.1667 7.50033V5.83366C14.1667 4.91318 13.4205 4.16699 12.5 4.16699H4.16667C3.24619 4.16699 2.5 4.91318 2.5 5.83366V10.8337C2.5 11.7541 3.24619 12.5003 4.16667 12.5003H5.83333M7.5 15.8337H15.8333C16.7538 15.8337 17.5 15.0875 17.5 14.167V9.16699C17.5 8.24652 16.7538 7.50033 15.8333 7.50033H7.5C6.57953 7.50033 5.83333 8.24652 5.83333 9.16699V14.167C5.83333 15.0875 6.57953 15.8337 7.5 15.8337ZM13.3333 11.667C13.3333 12.5875 12.5871 13.3337 11.6667 13.3337C10.7462 13.3337 10 12.5875 10 11.667C10 10.7465 10.7462 10.0003 11.6667 10.0003C12.5871 10.0003 13.3333 10.7465 13.3333 11.667Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.0d1ef69926d998aaa230a1b0d2413ea3.svg";
export { ForwardRef as ReactComponent };